import { clsx } from 'clsx'
import {
  type ComponentProps,
  type ComponentPropsWithRef,
  type ElementType,
  type JSX,
} from 'react'

export type BrandIconOwnProps = {
  /**
   * The color of the component
   * @default brand
   */
  color?: 'brand' | 'secondary'

  icon: ElementType<ComponentProps<'svg'>, 'svg'>

  /**
   * The size applied to the icon. Defaults to inherit font size.
   */
  size?: 'l' | 'm' | 's'
}

type BrandIconProps = BrandIconOwnProps &
  Omit<ComponentPropsWithRef<'svg'>, keyof BrandIconOwnProps>

export const BrandIcon = (props: BrandIconProps): JSX.Element => {
  const { className, color = 'brand', icon: Icon, size, ...rest } = props

  return (
    <Icon
      className={clsx(
        'brand-icon',
        color === 'brand' && 'brand-icon_color_brand',
        color === 'secondary' && 'brand-icon_color_secondary',
        size === 's' && 'brand-icon_size_s',
        size === 'm' && 'brand-icon_size_m',
        size === 'l' && 'brand-icon_size_l',
        className,
      )}
      {...rest}
    />
  )
}
